// @flow

import React, { Component } from 'react';
import styled from 'styled-components';
import { zIndexMap } from '../../helpers';
import type { Theme } from '../../types';

const Overlay = styled<any, Theme>('div')`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zIndexMap.overlay};
`;

type Props = {
  handleClose: Function,
};

const ESCAPE_KEY = 27;

class OverlayComponent extends Component<Props> {
  componentDidMount() {
    document.addEventListener('keyup', this.keyEvent);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.keyEvent);
  }

  clickEvent = () => {
    const { handleClose } = this.props;
    handleClose();
  }

  keyEvent = (e: KeyboardEvent) => {
    const { handleClose } = this.props;
    if (e.keyCode === ESCAPE_KEY) {
      handleClose();
    }
  }

  render() {
    return (
      <Overlay onClick={this.clickEvent} />
    );
  }
}

export default OverlayComponent;
